import { onBoardUserAPI } from "@/components/PageHome/api";
import { HOME_TYPE, onBoardUserAttr, SegmentInfo } from "@/components/PageHome/api/interface";
import { setError, setLoading } from "@/components/PageHome/redux/slice";
import { setCookie } from "@/helpers/cookies";

export const onBoardUser =
  () =>
  async (dispatch, getState): Promise<any> => {
    dispatch(setLoading(true));

    try {
      const { flowData, currentFlow } = getState().home;

      let payload: onBoardUserAttr = {
        type: currentFlow,
      };

      switch (currentFlow) {
        case HOME_TYPE.PRECONCEPTION:
          payload["averageCycle"] = flowData?.cycleLength;
          payload["firstDateOfLastPeriod"] = flowData?.periodDate;

          break;

        case HOME_TYPE.PREGNANCY:
        case HOME_TYPE.BIRTH:
          payload["dueDate"] = flowData?.dueDate;
          payload["averageCycle"] = flowData?.cycleLength;
          payload["firstDateOfLastPeriod"] = flowData?.periodDate;

          break;

        case HOME_TYPE.NEW_MOM:
          payload["childBirthDate"] = flowData?.birthDate;
          break;
      }

      const response = await onBoardUserAPI(payload);

      if (response?.status === 200 && response?.data) {
        const key = Object.keys(response.data).find((k) => k.includes("Content"));

        const segmentInfo: SegmentInfo = response?.data?.segmentInfo;

        if (segmentInfo && key) {
          setCookie("segmentInfo", JSON.stringify(segmentInfo));
          window.location.reload();
        } else {
          alert(`Error, ${response?.data?.message || "Something went wrong during API call"}`);

          return { status: "error" };
        }
      }
    } catch (error) {
      dispatch(setError({ error, message: "Failed to submit data" }));

      return { status: "error" };
    } finally {
      dispatch(setLoading(false));
    }
  };
